import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useQuery } from "@apollo/client";

import { Stars } from "../../../genericComponents";
import { Column, Row } from "../../../genericComponents/Layout";
import { GET_HELPFUL_COUNT } from "../../../../helpers/graphqlQueries";


const testsTranslate = {
  step_1: "Step 1",
  step_2: "Step 2",
  step_3: "Step 3",
  mcat: "MCAT",
};

export default function Review(props){
  const [reviewsVisibility, setReviewsVisibility] = useState(false);
  const [helpfulCount, setHelpfulCount] = useState(0);

  const { loading, refetch } = useQuery(GET_HELPFUL_COUNT, {
    variables: {
      resource_review_id: props.id,
    },
    onCompleted: (data) => {
      setHelpfulCount(data.helpful_review.length);
    },
    notifyOnNetworkStatusChange: true,
  });

  useEffect(() => {
    if (!loading) refetch();
  }, [props.isHelpful]);

  return (
    <MessageBox>
      <ReviewHead>
        <Stars color='yellow' numberOfStars={props.rating} />

        <ReviewSpan>on&nbsp;{String(props.createdAt).split(" ")[0]}</ReviewSpan>
        <ReviewSpan className='review-username'>
          by {props.username || "No user"}
        </ReviewSpan>
        <ReviewSpan className='review-username'>
          | &nbsp;Used for Studing
        </ReviewSpan>
      </ReviewHead>

      <MessageDescriptionContainer>
        <MessageDescription className='message-description'>
          <h4 className='message-heading'>{props.title || "No title"}</h4>
          <p className='message-paragraph'>{props.comment}</p>
        </MessageDescription>
        <TagsContainer>
          {props.specialties.map((tagitem, index) => (
            <Tag><h4>{tagitem}</h4></Tag>
          ))}
        </TagsContainer>
      </MessageDescriptionContainer>
      <ReviewBottom>
        <ActionButtons>
          <HelpfulButton
            onClick={() =>
              props.markReviewAsHelpful(props.id, !!props.isHelpful)
            }
            isHelpful={props.isHelpful}
          >
            {props.isHelpful ? "Not Helpful" : "Helpful"} {`(${helpfulCount})`}
          </HelpfulButton>
          <Button
            onClick={() =>
              props.handleReply({
                visibility: true,
                commentId: props.id,
              })
            }
          >
            Reply
          </Button>
          <Button
            onClick={() => {
              // window.$crisp.push(["do", "chat:open"]);
              // window.$crisp.push([
              //   "do",
              //   "message:send",
              //   ["text", "Hello I would like to report an abuse"],
              // ]);
            }}
          >
            <span className='icons-report'>&nbsp;</span> Report abuse
          </Button>
        </ActionButtons>
        <UsedInTestsContainer>
          <UsedInTestsTitle>Used In Test</UsedInTestsTitle>
          <UsedInTests>
            {props.usedInTests.map((test) => (
              <React.Fragment key={test}>
                <li>|</li>
                <li>{testsTranslate[test]}</li>
              </React.Fragment>
            ))}
          </UsedInTests>
        </UsedInTestsContainer>
      </ReviewBottom>
      <ReviewRepliesContainer reviewsVisibility={reviewsVisibility}>
        {props.replies && !!props.replies.length && (
          <ArrowContainer
            onClick={() =>
              setReviewsVisibility((currentValue) => !currentValue)
            }
          >
            <p>Show Comment Replies</p>
            <ToggleReviewsArrow reviewsVisibility={reviewsVisibility} />
          </ArrowContainer>
        )}
        {props.replies &&
          props.replies.map((reply) => (
            <p className='reply'>
              <strong>{reply.username}: </strong>
              {reply.comment}
            </p>
          ))}
      </ReviewRepliesContainer>
    </MessageBox>
  );
};



const MessageBox = styled.div`
  background-color: ${(props) => props.theme.color.softYellow};
  border-radius: 10px;
  padding: 20px 20px;
  margin: 20px 0px;
  display: flex;
  flex-direction: column;
  flex:1;

  .message-date span {
    &::before {
      background-color: ${(props) => props.theme.color.gabaYellow};
    }
  }

  .message-type span {
    &::before {
      background-color: ${(props) => props.theme.color.gabaYellow};
    }
  }

  div.message-bellow a {
    color: ${(props) => props.theme.color.darkBlue};
  }

  ul.author-link p {
    color: ${(props) => props.theme.color.darkBlue};
  }

  ul.author-link li {
    color: ${(props) => props.theme.color.darkBlue};
  }
`;

const MessageDescriptionContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const MessageDescription = styled.div`
  h4 {
    margin: 0 0 0.5rem;
    font-size: 1.5em;
    font-weight: 700;
    color: ${(props) => props.theme.color.darkBlue} !important;
  }

  p.message-paragraph {
    margin: 0 10px 20px 0px;
    width: 100% !important;
    color: ${(props) => props.theme.color.darkBlue} !important;
  }
`;

const Button = styled.button`
  height: 40px;
  font-weight: 500;
  padding: 0px 14px;
  line-height: 1.1;
  margin-right: 2px;
  color: ${(props) => props.theme.color.darkBlue};
  background-color: ${(props) => props.theme.color.softPurple};
  border-radius: 2px;
  outline: none;
  border: none;
  cursor: pointer;
`;
// const StyledStar = styled(Stars)`
  
//   margin: -10px -30px;
  
// `;

const ReviewRepliesContainer = styled(Column)`
  width: 100%;
  max-height: ${({ reviewsVisibility }) => (reviewsVisibility ? "1000px" : 0)};
  transition: max-height 0.5s ease-in;
  position: relative;

  p {
    font-size: 20px;
    text-align: left;
  }
  p.reply {
    margin: 15px 0px;
    opacity: ${({ reviewsVisibility }) => (reviewsVisibility ? "1" : "0")};
    transition: opacity 0.2s ease;
  }
`;

const ArrowContainer = styled(Row)`
  width: 100%;
  justify-content: left;
  font-size: 14px;
  cursor: pointer;
  p {
    margin: -20px 0px;
  }
`;

const ToggleReviewsArrow = styled.div`
  width: 7px;
  height: 7px;
  border: 2px solid black;
  transform: ${({ reviewsVisibility }) =>
    reviewsVisibility ? "rotate(225deg)" : "rotate(45deg)"};
  border-top: none;
  border-left: none;
  margin-left: 10px;
  margin-bottom: 0px;
  margin-top: -10px;
  transition: transform 0.4s linear;
`;

const TagsContainer = styled.div`
  display: flex;
  max-width: 270px;
  flex-wrap: wrap;
  justify-content: center;
`;

const Tag = styled.div`
  color: ${(props) => props.theme.color.darkBlue};
  background-color: ${(props) => props.theme.color.softPurple};
  height: fit-content;
  padding: 8px 16px;
  text-align: center;
  border-radius: 5px;
`;

const ReviewSpan = styled.span`
  line-height: 2em;
  margin-left: 12px;
  margin-top:6px;
  &&&.review-username {
    font-weight: 700;
  }
`;
const ReviewHead = styled.div`
  color: ${(props) => props.theme.color.darkBlue};
  margin-bottom: 15px;
  font-weight: 500;
  display: flex;
  flex: 1;
  align-items: flex-start;
`;
const ReviewBottom = styled.div`
  display: flex;
`;
const ActionButtons = styled.div`
  display: flex;
  justify-content: space-evenly;
  flex: 2;
  margin-bottom: 30px;
`;
const UsedInTests = styled.ul`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  flex-direction: row;
  /* min-width: 274px; */
  font-size: 16px;

  li {
    display: inline-block;
    list-style: none;
    margin: 0 4px;
    text-align: center;
    font-weight: 700;
    color: ${(props) => props.theme.color.darkBlue};
  }
`;
const UsedInTestsContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex:1;
`;
const UsedInTestsTitle = styled.p`
  text-align: center;
  line-height: 1em;
  font-weight: 700;
  color: ${(props) => props.theme.color.darkBlue};
`;
const HelpfulButton = styled(Button)`
  margin-right: 2px;  
  ${(props) =>
    props.isHelpful ? `background-color: ${props.theme.color.gabaYellow}` : ""}
`;